import { Button, DataSource, HorizontalSpacer, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiTemplateQuickInfo extends Layout {
    buttonDetail: Button;
    horizontalspacer1: HorizontalSpacer;
    sourceEdiTemplate: DataSource;
    textboxFilepath: Textbox;
    textboxId: Textbox;
    textboxName: Textbox;
}
